import store from "@/store/instance";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import { IQuestion, DecorationType, ITextTData, IAddonData, IFillInData, IImageData, IMultipleChoiceData, IPhoneNumberData, IQuestionComonentType, IQuestionItem, ISelectedoptionsData, ISingleChoiceData, QuestionFormDataType, QuestionType, questionData } from "../config/questionnaire";
import { getQuestionnaireDetail, saveQuestionnaire, saveQuestionnaireDraft, getQuestionnaireDraftByCommtyId, checkItemExist } from "@modules/newCommunity/pages/operationTools/api/questionnaire";
import { walkArray } from "@/utils/commonUtil";
export interface QuestionFromData {
  componentName: QuestionType | DecorationType;
  componentType: IQuestionComonentType;
  data: QuestionFormDataType;
}

export enum QuestionnaireSettingAction {
  basic_setting = 0,
  empty = -1,
  question = 1,
  submitBtn = 2,
  submitPageBtn = 3,
}
const defaultForm = {
  questionData: {
    uniqueId: "", // $ 问卷唯一id
    title: "标题", // 标题
    introduce: "", // 介绍
    remark: "", //备注
    hideIntro: 0,
    exitPopup: "0",
    coverUrl: "", // 封面
    tips: "确定要放弃填写吗？",
    submitTitle: "提交",
    submitText: "本活动最终解释权归爱问所有",
    status: "",
    userAuth: 0,
    popupText: "确定要放弃填写吗？ ",
    leaveBtnText: "确认",
    cancelBtnText: "取消",
  }, // $ 问卷调查数据
  basicData: {
    title: "标题", // 标题
    remark: "", //备注
    coverSet: true,
    cover: "", // 封面
    coverIntroduce: "", // 介绍
    coverBtnText: "开始答题",
    shareSet: true,
    shareCover: "https://picture.wenwo.com/fimg/2f3582051f736b9520448c8ef6693a12.jpg",
    shareTitle: "",
    shareIntroduce: "",
    submitLimit: true,
    submitLimitCount: 1,
    loginSet: true,
    joinDoctorLimit: "COMMUNITYDOCTOR",
    joinDoctorType: [],
    exitPopup: "1",
    popupText: "确定要放弃填写吗？",
    pageSet: "COMBINE",
  },
  submitData: {
    countdown: 3, // $ 倒计时(单位:秒)
    jumpLinkType: 1, // $ 跳转方式 1: 社区内容 2: 外部链接
    jumpType: 0, // $ 跳转类型 0:自动跳转 1:手动跳转
    linkUrl: "index", // $ 跳转地址
    picUrl: "", // $ 图片地址
    questionnaireId: "", // $ 问卷ID
    qualifiedScore: 0, // $ 问卷ID
    tips: "正在转入社区首页，请稍后", // $ 副语
    title: "您的答卷已经提交，感谢您的参与！", // $ 标题
  },
  activeIndex: 0, // $ 当前点击索引
  dataList: [] as Array<QuestionFromData>,
};
const jumpUrl = {
  index: {
    label: "社区首页",
    url: "index",
    value: "index",
  },
  doctors: {
    label: "名医诊室",
    url: "doctors",
    value: "doctors",
  },
  institution: {
    label: "机构列表",
    url: "institution",
    value: "institution",
  },
  tieba: {
    label: "健康圈",
    url: "tieba",
    value: "tieba",
  },
  topics: {
    label: "话题列表",
    url: "topics",
    value: "topics",
  },
  questions: {
    label: "问答列表",
    url: "tieba#qA",
    value: "questions",
  },
  article: {
    label: "文章资讯",
    url: "article",
    value: "article",
  },
  introduce: {
    label: "社区简介",
    url: "mine/about",
    value: "introduce",
  },
};

type BasicData = typeof defaultForm.basicData;
type SubmitData = typeof defaultForm.submitData;
@Module({
  name: "questionnaireEditNew",
  dynamic: true,
  namespaced: true,
  store,
})
export default class QuestionnaireEdit extends VuexModule {
  public questionnaireType = "QUESTIONNAIRE";
  public questionnaireSource = "PATIENT";
  public totalScore = "0";
  public jumpUrl = jumpUrl as any;
  public action = QuestionnaireSettingAction.basic_setting;
  public questionData = defaultForm.questionData; // $ 问卷调查数据
  public submitData = defaultForm.submitData;
  public basicData = defaultForm.basicData;
  public activeIndex = defaultForm.activeIndex; // $ 当前点击索引
  public dataList = defaultForm.dataList;
  public dattpaList = defaultForm.dataList;
  public activeData = { componentName: QuestionType.empty, componentType: IQuestionComonentType.Question, data: {} } as QuestionFromData;

  public stagDataList: any = [];

  // $ 基本信息设置
  @Mutation
  SET_QUESTIONTYPE_DATA(tp: string) {
    this.questionnaireType = tp;
  }
  @Mutation
  SET_QUESTIONNAIRESOURCE_DATA(tp: string) {
    this.questionnaireSource = tp;
  }
  @Mutation
  SET_TOTALSCORE_DATA(tp: string) {
    this.totalScore = tp;
  }

  // @Mutation
  // SET_BASICS_DATA() {
  //   this.action = QuestionnaireSettingAction.basic_setting;
  // }
  // $ 提交按钮设置
  @Mutation
  SET_SUBMIT_DATA() {
    this.action = QuestionnaireSettingAction.submitBtn;
  }
  // $ 设置当前点击索引
  @Mutation
  SET_INDEX_COMPONENTS(index: any) {
    this.action = QuestionnaireSettingAction.question;
    this.activeIndex = index;
    this.activeData = this.dataList[index];
  }
  // $ 拖动组件数据
  @Mutation
  SET_DATALIST_COMPONENTS(payload: any) {
    this.dataList = payload;
  }
  // $ 添加组件
  @Mutation
  SET_ADD_COMPONENTS(payload: { item: IQuestionItem<any>; index: number }) {
    const item = payload.item;
    const data = {
      componentName: item.componentName,
      componentType: item.type,
      data: {
        ...item.data,
        title: item.title,
        catalogIds: [],
        whetherJoinQuestionBank: false,
      },
    };
    this.dataList.splice(this.activeIndex + 1, 0, data);
  }
  @Mutation
  UPDATE_COMPONENTS(payload: { item: any; index: number }) {
    this.dataList[payload.index].data = payload.item;
  }
  // $ 删除组件
  @Mutation
  SET_DELETE_COMPONENTS(payload: any) {
    console.warn("payload", payload);
    this.dataList.splice(payload, 1);
    console.warn("dataList", this.dataList);
    if (this.dataList.length == 0) {
      this.action = QuestionnaireSettingAction.basic_setting;
    }
  }
  // $ 问卷调查数据
  @Mutation
  SET_BASIC_DATA(payload: any) {
    this.basicData = payload;
  }
  // $ 获取问卷调查数据
  @Mutation
  SET_DATA_LIST(payload: any) {
    this.dataList = payload;
  }
  // $ 获取提交页设置数据
  @Mutation
  SET_SUBMIT_LIST(payload: any) {
    this.submitData = payload;
  }
  @Mutation
  SET_BASIC_LIST(payload: any) {
    this.basicData = payload;
  }
  @Mutation
  SET_BASIC_DATA_SHARECOVER(payload: any) {
    this.basicData.shareCover = payload;
  }
  // $ 重置数据
  @Mutation
  SET_RESET_STORE() {
    this.questionnaireType = "QUESTIONNAIRE";
    this.questionData = JSON.parse(JSON.stringify(defaultForm.questionData));
    this.submitData = JSON.parse(JSON.stringify(defaultForm.submitData));
    if (this.questionnaireSource == "DOCTOR") {
      this.submitData.jumpLinkType = 2;
      this.submitData.linkUrl = "";
    }
    this.basicData = JSON.parse(JSON.stringify(defaultForm.basicData));
    this.activeIndex = JSON.parse(JSON.stringify(defaultForm.activeIndex));
    this.dataList = JSON.parse(JSON.stringify(defaultForm.dataList));
  }
  // $
  @Mutation
  SET_NUMBER_INDEX(payload: any) {
    this.dataList[payload.index].data.number = payload.number;
  }
  // * 设置从题库中选择的数据
  @Mutation
  SET_STAG_DATA_LIST(payload: any) {
    this.stagDataList = payload;
  }
  // * 重置从题库中选择的数据
  @Mutation
  RESET_STAG_DATA_LIST() {
    this.stagDataList = [];
  }
  // // $ 隐藏问卷介绍
  // @Mutation
  // SET_HIDE_INTRO(payload: any) {
  //   this.questionData.hideIntro = payload;
  // }

  // @Action({commit: 'updatePosts'})
  // async function fetchPosts() {
  //     return await get('https://jsonplaceholder.typicode.com/posts')
  // }
  // $ 获取问卷详情
  @Action
  public GET_QUESTIONNAIRE_DETAIL(params: any) {
    getQuestionnaireDetail(params).then((data: any) => {
      const result = transformToUIData(data);
      console.warn("transformToUIData", result);
      this.SET_QUESTIONTYPE_DATA(data.questionnaireType);
      this.SET_BASIC_DATA(result.basicData);
      this.SET_DATA_LIST(result.datalist);
      this.SET_SUBMIT_LIST(result.submitData);
    });
  }

  // $ 保存暂存数据
  @Action
  async SAVE_QUESTIONNAIRE_DRAFT() {
    const basicData = this.basicData;
    const questionnaireType = this.questionnaireType;
    const questionnaireSource = this.questionnaireSource;
    const params = transformToServerData(store.state, questionnaireType, questionnaireSource, basicData, this.dataList, this.submitData);

    return saveQuestionnaireDraft(params as any)
      .then((data: any) => {
        return data;
      })
      .catch((error) => {
        return error;
      });
  }
  // $ 保存问卷
  @Action
  async SAVE_QUESTIONNAIRE(id: string) {
    const basicData = this.basicData;
    const questionnaireType = this.questionnaireType;
    const questionnaireSource = this.questionnaireSource;
    const params = transformToServerData(store.state, questionnaireType, questionnaireSource, basicData, this.dataList, this.submitData);
    params.id = id;
    return await saveQuestionnaire(params as any)
      .then((data: any) => {
        return data;
      })
      .catch((error) => {
        return error;
      });
  }
  // $ 获取暂存数据
  @Action
  async GET_QUESTIONNAIREDraftByCommtyId() {
    // const questionData = this.questionData;
    return getQuestionnaireDraftByCommtyId({ communityId: store.state.comtyId, questionnaireType: this.questionnaireType, questionnaireSource: this.questionnaireSource })
      .then((res: any) => {
        console.warn("getQuestionnaireDraftByCommtyId", res);
        const data: any = res.data;
        if (Object.keys(data).length > 1) {
          const result = transformToUIData(data);
          this.SET_BASIC_DATA(result.basicData);
          this.SET_DATA_LIST(result.datalist);
          this.SET_SUBMIT_LIST(result.submitData);
        }
        return data;
      })
      .catch((error) => {
        return error;
      });
  }
  @Action
  async CHECK_DATA() {
    const basicData = this.basicData;
    const questionnaireType = this.questionnaireType;
    const questionnaireSource = this.questionnaireSource;
    const params = transformToServerData(store.state, questionnaireType, questionnaireSource, basicData, this.dataList, this.submitData);
    return await checkItemExist(params as any)
      .then((data: any) => {
        return data;
      })
      .catch((error) => {
        return error;
      });
  }
}

// !初始化问卷答题数据
export function transformToUIData(data: any) {
  const basicData = {
    uniqueId: data.id || undefined,

    title: data.title, // 标题
    remark: data.remark, //备注
    coverSet: data.coverSet || false,
    cover: data.cover || "", // 封面
    coverIntroduce: data.coverIntroduce || "", // 介绍
    coverBtnText: data.coverBtnText || "",
    shareSet: data.shareSet || false,
    shareCover: data.shareCover || "https://picture.wenwo.com/fimg/2f3582051f736b9520448c8ef6693a12.jpg",
    shareTitle: data.shareTitle || "",
    shareIntroduce: data.shareIntroduce || "",
    submitLimit: data.submitLimit || false,
    submitLimitCount: data.submitLimitCount || 1,
    loginSet: data.loginSet || false,
    joinDoctorLimit: data.joinDoctorLimit || "COMMUNITYDOCTOR",
    joinDoctorType: data.joinDoctorType || [],
    exitPopup: data.exitPopup + "",
    popupText: data.popupText,
    pageSet: data.pageSet,
  };
  const serviceSubmitData = data.submitItemList[0];
  const submitData = {
    countdown: serviceSubmitData.countdown, // $ 倒计时(单位:秒)
    jumpLinkType: serviceSubmitData.jumpLinkType || 1, // $ 跳转方式 1: 社区内容 2: 外部链接
    jumpType: serviceSubmitData.jumpType || 0, // $ 跳转类型 0:自动跳转 1:手动跳转
    linkUrl: serviceSubmitData.linkUrl, // $ 跳转地址
    picUrl: serviceSubmitData.picUrl, // $ 图片地址
    questionnaireId: serviceSubmitData.questionnaireId, // $ 问卷ID
    tips: serviceSubmitData.tips, // $ 副语
    title: serviceSubmitData.title, // $ 标题    qualifiedScore: 0, // $ 问卷ID
    qualifiedScore: data.qualifiedScore || 0, // $ 标题
  };
  const datalist = [] as Array<any>;
  walkArray(data.itemList, (item) => {
    const question = {
      componentName: item.type as string,
      data: {
        id: item.id,
        required: item.required,
        number: item.number,
        type: item.componentName,
        style: item.componentType,
        whetherJoinQuestionBank: item.joinBank || false,
        fromQuestionBank: !!item.fromQuestionBank,
        catalogIds: item.catalogIds || [],
      },
    };
    if (item.type == QuestionType.singleChoice || item.type == QuestionType.multipleChoice || item.type == QuestionType.cascade) {
      const data = question.data as IMultipleChoiceData | ISingleChoiceData;
      data.optionsList = item.optionsList;
      data.title = item.question;
      data.optionContentType = item.optionContentType;
      data.itemScore = item.itemScore || 0;
      //       optionContentType: string; // 是否必填: number;
      // itemScore?: number;
    }

    if (item.type == DecorationType.picture) {
      const data = question.data as IImageData;
      try {
        const jsonConfig = JSON.parse(item.jsonConfig);
        data.url = jsonConfig.url;
      } catch (error) {
        console.log(error, item.jsonConfig);
        data.url = "";
      }
    }
    if (item.type == DecorationType.text) {
      const data = question.data as ITextTData;
      try {
        const jsonConfig = JSON.parse(item.jsonConfig);
        data.text = jsonConfig.text;
      } catch (error) {
        console.log(error, item.jsonConfig);
        data.text = "";
      }
    }
    if (item.type == QuestionType.uploadAddon) {
      const data = question.data as IAddonData;
      data.title = item.question;
      data.uploadLimitCount = item.uploadLimitCount;
    }

    if (item.type == QuestionType.phoneNumber) {
      const data = question.data as IPhoneNumberData;
      data.title = item.question;
      try {
        const jsonConfig = JSON.parse(item.jsonConfig);
        data.phoneNumber = jsonConfig.default; //填空题的默认文本
      } catch (error) {
        console.log(error, item.jsonConfig);
        data.phoneNumber = "";
      }
    }
    if (item.type == QuestionType.fillIn) {
      const data = question.data as IFillInData;
      data.title = item.question;

      data.itemScore = item.itemScore;
      data.rightText = item.rightText;
      data.scoreRule = item.scoreRule;
      try {
        const jsonConfig = JSON.parse(item.jsonConfig);
        data.content = jsonConfig.default; //填空题的默认文本
      } catch (error) {
        console.log(error, item.jsonConfig);
        data.content = "";
      }
    }
    // (question.data as IQuestion).whetherJoinQuestionBank = false;
    datalist.push(question);
  });
  return { basicData, datalist, submitData };
}
function transformToServerData(rootState: any, questionnaireType: string, questionnaireSource: string, basicData: BasicData, dataList: Array<QuestionFromData>, submitData: SubmitData) {
  const itemList = transformDataListToServerData(dataList);
  const params: any = {
    questionnaireType,
    questionnaireSource,
    ...basicData,
    submitItemList: [submitData],
    qualifiedScore: submitData.qualifiedScore || 0,
    itemList: itemList,
  };
  if (questionnaireSource == "PATIENT") {
    delete params.joinDoctorLimit;
    delete params.joinDoctorType;
  }
  console.log("transformToServerData", params);
  return params;
}
export function transformDataListToServerData(datalist: Array<QuestionFromData>) {
  const data = datalist.map((item) => {
    const formData = item.data;
    console.warn("formData", formData);
    const question: any = {
      required: formData.required,
      type: item.componentName,
      style: item.componentType,
      number: formData.number,
      catalogIds: formData.catalogIds || [],
      joinBank: !!formData.whetherJoinQuestionBank,
      fromQuestionBank: !!formData.fromQuestionBank,
    };
    if (formData.id) question.id = formData.id;
    if (item.componentName == QuestionType.singleChoice || item.componentName == QuestionType.multipleChoice || item.componentName == QuestionType.cascade) {
      question.optionsList = (formData as ISingleChoiceData).optionsList;
      question.question = (formData as ISingleChoiceData).title;
      question.itemScore = (formData as ISingleChoiceData).itemScore;
      question.optionContentType = (formData as ISingleChoiceData).optionContentType;
    }

    if (item.componentName == QuestionType.fillIn) {
      const jsonConfig = { default: (formData as IFillInData).content };
      question.jsonConfig = JSON.stringify(jsonConfig);
      question.question = (formData as IFillInData).title;
      question.itemScore = (formData as IFillInData).itemScore;
      question.rightText = (formData as IFillInData).rightText;
      question.scoreRule = (formData as IFillInData).scoreRule;
    }

    if (item.componentName == DecorationType.picture) {
      const jsonConfig = { url: (formData as IImageData).url };
      question.jsonConfig = JSON.stringify(jsonConfig);
    }
    if (item.componentName == DecorationType.text) {
      const jsonConfig = { text: (formData as ITextTData).text };
      question.jsonConfig = JSON.stringify(jsonConfig);
    }
    if (item.componentName == QuestionType.phoneNumber) {
      const jsonConfig = { default: (formData as IPhoneNumberData).phoneNumber };
      question.jsonConfig = JSON.stringify(jsonConfig);
      question.question = (formData as IPhoneNumberData).title;
    }
    if (item.componentName == QuestionType.uploadAddon) {
      const data = formData as IAddonData;
      question.question = data.title;
      question.uploadLimitCount = data.uploadLimitCount;
    }
    return question;
  });
  return data;
}

export const QuestionnaireEditModule = getModule(QuestionnaireEdit);
